import { transactionType } from "../constants/ThresholdsConstants";
import dayjs from 'dayjs';

// Function that converts a date from "EEE MMM dd YYYY HH:mm:ss GMT+XXXX (TimeZoneName)" format to "dd/mm/YYYY" format
export const reverseConvertDate = (formattedDateString: string): string => {
    const date = new Date(formattedDateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();
    const dateString = `${day}/${month}/${year}`;
    return dateString;
};

export const offsetDateJsConvert = (date: string, format: string ) : string => {
    const dateToConvert = dayjs.utc(date, format);
    const isoString = dateToConvert.utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
    return isoString;
}

export const enrichUpdateThreshold = (data: any, { threshold }: any) => {
    data["sap-id"] = threshold?.["sap-id"];
    data.id = threshold?.id;
    data.threshold = fixThresholdValue(data.threshold);
    data['customer-name'] = threshold?.["customer-name"];
}

export const convertTypology = (value: string) => {
    const item = transactionType.find((item) => item.value === value);
    return item ? item.label : value;
  }

export const fixThresholdValue = (value: any) => {
    return value ? value * 100 : value;
}


